import { NAV_LINKS } from "./Nav";
import { useDonate } from "./DonateModal";

export const Footer = () => {
  const openDonate = useDonate();
  return (
  <footer className="site-footer" data-testid="site-footer">
    <div className="wrap">
      <div className="foot">
        <img src="/assets/logo-dark.jpg" alt="Davis Infinite Care Corporation" />
        <nav aria-label="Footer">
          {NAV_LINKS.map(({ id, label }) => <a key={id} href={`#${id}`} data-testid={`footer-link-${id}`}>{label}</a>)}
          <button type="button" onClick={openDonate} data-testid="footer-donate-button">Donate</button>
        </nav>
      </div>
      <p className="motto">Empowering <i>youth.</i> Strengthening <i>families.</i> Inspiring <i>communities.</i></p>
      <div className="foot-bottom">
        <div>
          <p className="copy" style={{ marginBottom: ".4rem" }}>
            <a href="tel:+19547369078">954-736-9078</a> &nbsp;|&nbsp; <a href="tel:+18437989979">843-798-9979</a> &nbsp;|&nbsp;{" "}
            <a href="mailto:jeanine@davisinfinitecarecorp.com">Jeanine@davisinfinitecarecorp.com</a>
          </p>
          <p className="copy">© {new Date().getFullYear()} Davis Infinite Care Corporation. All rights reserved.</p>
        </div>
        <p className="credit" data-testid="footer-credit">
          Designed &amp; Developed by{" "}
          <a href="https://www.sparkplug.one/" target="_blank" rel="noopener noreferrer" data-testid="footer-sparkplug-link">Spark Plug</a>
        </p>
      </div>
    </div>
  </footer>
  );
};
